// extracted by mini-css-extract-plugin
export default {"input":"TimeOptions_input__Izu9q"};